<template>
  <div v-if="showTemplateSlider">
    <div class="meta">
      <div>
        <h2 v-if="category" class="template-slider-title">
          <router-link :to="path">
            {{ $apollo.loading ? "Loading..." : category.label }}
          </router-link>
        </h2>

        <p class="template-slider-description">
          {{
            $apollo.loading
              ? "Templates will appear shortly"
              : category.description
          }}
        </p>
      </div>

      <router-link
        v-if="maximumTemplatesLoaded"
        :to="path"
        class="template-slider-link"
        >See all</router-link
      >
    </div>

    <Error
      v-if="!$apollo.loading && errors.length"
      :errors="errors"
      class="m-4"
    />

    <Loader
      v-if="$apollo.loading && !errors.length"
      label="Loading Templates..."
      class="mt-4 mb-6"
    />

    <PromoSlider
      v-if="!$apollo.loading && templates && templates.length"
      :key="templates.length"
      :slides-to-show="5.5"
      :slides-to-scroll="1"
      :arrows="true"
      :dots="false"
      :draggable="maximumTemplatesLoaded"
      :scroll-lock="false"
      :see-all-path="path"
    >
      <template #slides>
        <TemplatePreviewCard
          v-for="template in templates"
          :id="template.baseTemplateId"
          :key="template.baseTemplateId"
          :name="template.name"
          :price="template.price"
          :to="`${path}/${template.baseTemplateId}`"
          :img-url="$get(template, 'previewImage.src')"
          class="mr-4 md:mr-6"
        />
      </template>
    </PromoSlider>
  </div>
</template>

<script>
import { BaseTemplates } from "@/graphql/queries";
import PromoSlider from "@/components/UI/PromoSlider";
import TemplatePreviewCard from "@/components/Templates/TemplatePreviewCard";
import Loader from "@/components/UI/Loader";
import Error from "@/components/UI/Error";

export default {
  apollo: {
    $query: {
      fetchPolicy: "cache-first",
    },
    templates: {
      query: BaseTemplates,
      error(error) {
        this.errors.push(error);
      },
      variables: function() {
        return {
          input: { categoryId: this.category.categoryId, limit: 10 },
        };
      },
      manual: true, // disable the automatic property update for pagination to work. Need to specify a result callback...
      result({ data, loading }) {
        if (!loading) {
          // If baseTemplates or paginationKey are null then set them to an empty array...
          this.templates = data?.baseTemplates?.baseTemplates ?? [];
          this.paginationKey = data?.paginationKey?.paginationKey ?? [];

          // If there's no templates then hide this component...
          if (!this.templates.length) this.showTemplateSlider = false;
        }
      },
    },
  },
  name: "TemplateSlider",
  components: { Error, Loader, PromoSlider, TemplatePreviewCard },
  props: {
    category: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      errors: [],
      showTemplateSlider: true,
      templates: [],
    };
  },
  computed: {
    maximumTemplatesLoaded() {
      return this.templates && this.templates.length === 10;
    },
    path() {
      return `/templates/${this.category.categoryId}`;
    },
  },
};
</script>

<style scoped>
.meta {
  @apply flex flex-wrap items-center mb-1;
}

.template-slider-title {
  @apply flex-1 mb-0 text-base mb-1;

  a {
    @apply text-support;

    &:hover {
      @apply text-brand no-underline;
    }
  }

  @screen md {
    @apply text-xl;
  }
}

.template-slider-description {
  @apply text-grey-dark text-xs mb-0;

  @screen md {
    @apply mb-4;
  }

  @screen xl {
    @apply mb-0;
  }
}

.template-slider-link {
  @apply text-xs ml-auto text-right;
}

>>> .glider {
  @apply py-2 mb-6;

  @screen md {
    @apply p-2 mb-8;
    margin-right: 2.5rem;
  }

  @screen lg {
    @apply mb-10;
  }

  @screen xl {
    @apply p-4;
  }
}

>>> .glider-wrap {
  @screen md {
    @apply -mx-10;
  }

  @screen xl {
    @apply -ml-12;
  }
}

>>> .glider-prev,
>>> .glider-next {
  @apply hidden;

  @screen md {
    @apply block;
  }
}

>>> .glider-prev {
  @screen md {
    left: 1.5rem;
  }

  @screen xl {
    left: 1.9rem;
  }
}

>>> .glider-next,
>>> .glider-see-all {
  right: 1.5rem;
}

>>> .template-preview-card {
  max-width: 233px;
}

>>> .error {
  @apply m-0 p-2 !important;
  max-width: 480px;
}
</style>
